/* SMITHS 2.0 — behaviour for the s2-* sections.
   Overlays (menu, search, saved, finder), desktop mega panels, bag count,
   saved watches (no account needed), predictive search, the three-question
   finder, "add all" for Shop the Look, and the Kuwait City clock.
   Defensive: every feature checks for its markup first and fails silently. */
(function () {
  'use strict';
  if (window.S2) return;
  var d = document;
  var AR = (d.documentElement.lang || '').toLowerCase().indexOf('ar') === 0;
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || (AR ? '/ar/' : '/');
  var T = window.__s2t || {};
  function t(k, fb) { return T[k] || fb || k; }
  function $(s, r) { return (r || d).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || d).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function ls(k, v) { try { if (v === undefined) return JSON.parse(localStorage.getItem(k) || 'null'); localStorage.setItem(k, JSON.stringify(v)); } catch (e) { return null; } }
  function kd(n) { /* n = dinars as number */
    var s = (Math.round(n * 1000) % 1000 === 0) ? String(Math.round(n)) : n.toFixed(3);
    return s + (AR ? ' د.ك' : ' KD');
  }

  /* ---------- overlays ---------- */
  var lastFocus = null;
  function openOv(name, opts) {
    var ov = $('[data-s2-ov="' + name + '"]');
    if (!ov) return false;
    $$('.s2-ov.is-open').forEach(function (o) { if (o !== ov) o.classList.remove('is-open'); });
    lastFocus = d.activeElement;
    ov.classList.add('is-open');
    d.documentElement.classList.add('s2-lock');
    if (name === 'saved') renderSaved();
    if (name === 'finder') finderReset();
    if (opts && opts.expand) { var b = $('[data-s2-acc="' + opts.expand + '"]', ov); if (b) toggleAcc(b, true); }
    var f = $('[data-s2-autofocus]', ov) || $('button, a, input', ov);
    setTimeout(function () { try { f && f.focus(); } catch (e) {} }, 30);
    return true;
  }
  function closeOv() {
    $$('.s2-ov.is-open').forEach(function (o) { o.classList.remove('is-open'); });
    d.documentElement.classList.remove('s2-lock');
    try { lastFocus && lastFocus.focus(); } catch (e) {}
  }
  function toggleAcc(btn, force) {
    var id = btn.getAttribute('aria-controls');
    var sub = id && d.getElementById(id);
    var open = force !== undefined ? force : btn.getAttribute('aria-expanded') !== 'true';
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (sub) sub.hidden = !open;
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-s2-open]');
    if (o) {
      var v = o.getAttribute('data-s2-open').split(':');
      if (openOv(v[0], { expand: v[1] })) { e.preventDefault(); }
      return;
    }
    if (e.target.closest('[data-s2-close]')) { e.preventDefault(); closeOv(); return; }
    var a = e.target.closest('[data-s2-acc]');
    if (a) { e.preventDefault(); toggleAcc(a); return; }
    var mg = e.target.closest('[data-s2-mega]');
    if (mg && window.matchMedia('(min-width: 1024px)').matches) { e.preventDefault(); toggleMega(mg.getAttribute('data-s2-mega')); return; }
    if (!e.target.closest('.s2-mega')) closeMega();
  });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeOv(); closeMega(); } });

  /* ---------- desktop mega ---------- */
  function closeMega() { $$('.s2-mega.is-open').forEach(function (m) { m.classList.remove('is-open'); }); $$('[data-s2-mega]').forEach(function (b) { b.classList.remove('is-open'); b.setAttribute('aria-expanded', 'false'); }); }
  function toggleMega(name) {
    var m = $('[data-s2-megapanel="' + name + '"]');
    if (!m) return;
    var was = m.classList.contains('is-open');
    closeMega();
    if (!was) { m.classList.add('is-open'); $$('[data-s2-mega="' + name + '"]').forEach(function (b) { b.classList.add('is-open'); b.setAttribute('aria-expanded', 'true'); }); }
  }

  /* ---------- bag count ---------- */
  function setCount(n) { $$('[data-s2-cart-count]').forEach(function (el) { el.textContent = n; el.setAttribute('data-count', n); }); }
  function refreshCart() { fetch(ROOT + 'cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) { if (c && typeof c.item_count === 'number') setCount(c.item_count); }).catch(function () {}); }
  if (window.fetch) {
    var of = window.fetch;
    window.fetch = function (input) {
      var p = of.apply(this, arguments);
      try {
        var u = typeof input === 'string' ? input : (input && input.url) || '';
        if (/\/cart\/(add|change|update|clear)/.test(u)) p.then(function () { setTimeout(refreshCart, 150); }).catch(function () {});
      } catch (e) {}
      return p;
    };
  }
  ['cart:updated', 'cart:refresh', 'eurus:cart:redirect'].forEach(function (ev) { d.addEventListener(ev, function () { setTimeout(refreshCart, 150); }); });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- saved watches (localStorage, no account) ---------- */
  var SK = 's2_saved_v1';
  function saved() { return ls(SK) || []; }
  function paintSaved() {
    var list = saved();
    var hs = list.map(function (x) { return x.h; });
    $$('[data-s2-save]').forEach(function (b) { b.setAttribute('aria-pressed', hs.indexOf(b.getAttribute('data-s2-save')) > -1 ? 'true' : 'false'); });
    $$('[data-s2-saved-count]').forEach(function (el) { el.textContent = list.length || ''; });
  }
  function renderSaved() {
    var box = $('[data-s2-saved-list]');
    if (!box) return;
    var list = saved();
    if (!list.length) { box.innerHTML = '<p class="s2-body s2-muted" style="padding: 28px 20px">' + esc(t('saved_empty')) + '</p>'; return; }
    box.innerHTML = list.map(function (x) {
      return '<div class="s2-savedrow"><a class="s2-field" href="' + esc(x.u) + '">' + (x.i ? '<img class="s2-cover" src="' + esc(x.i) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<a href="' + esc(x.u) + '" style="display:flex;flex-direction:column;gap:3px;flex-grow:1;min-width:0"><span class="s2-mono s2-muted">' + esc(x.v) + '</span><span style="font-size:16px;font-weight:600;line-height:1.25">' + esc(x.t) + '</span><span class="s2-price">' + esc(x.p) + '</span></a>' +
        '<button type="button" class="s2-btn s2-btn--line" style="min-height:44px;padding:0 14px;font-size:15px" data-s2-unsave="' + esc(x.h) + '">' + esc(t('remove')) + '</button></div>';
    }).join('');
  }
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-s2-save]');
    if (b) {
      e.preventDefault();
      var h = b.getAttribute('data-s2-save'), list = saved(), i = -1;
      list.forEach(function (x, k) { if (x.h === h) i = k; });
      if (i > -1) list.splice(i, 1);
      else list.unshift({ h: h, t: b.getAttribute('data-t'), p: b.getAttribute('data-p'), u: b.getAttribute('data-u'), i: b.getAttribute('data-i'), v: b.getAttribute('data-v') });
      ls(SK, list.slice(0, 60)); paintSaved();
      return;
    }
    var u = e.target.closest('[data-s2-unsave]');
    if (u) { var hh = u.getAttribute('data-s2-unsave'); ls(SK, saved().filter(function (x) { return x.h !== hh; })); paintSaved(); renderSaved(); }
  });

  /* ---------- predictive search ---------- */
  var sq = null, sTimer = null;
  function searchRender(q, data) {
    var box = $('[data-s2-sresults]');
    if (!box) return;
    if (!q) { box.innerHTML = ''; $$('[data-s2-sidle]').forEach(function (el) { el.hidden = false; }); return; }
    $$('[data-s2-sidle]').forEach(function (el) { el.hidden = true; });
    var r = (data && data.resources && data.resources.results) || {};
    var html = '';
    (r.queries || []).slice(0, 3).forEach(function (x) {
      html += '<a href="' + esc(loc(x.url)) + '" class="s2-mrow" style="border:0;min-height:52px">' + '<span style="display:flex;color:#655E51">' + ICON_SEARCH + '</span><span class="s2-mrow__l">' + (x.styled_text || esc(x.text)) + '</span></a>';
    });
    var ps = r.products || [];
    if (ps.length) {
      html += '<div class="s2-mlabel" style="padding-top:14px"><span class="s2-mono s2-muted">' + esc(t('s_products')) + '</span></div>';
      ps.slice(0, 5).forEach(function (p) {
        var price = parseFloat(p.price || p.price_min || 0);
        html += '<a href="' + esc(loc(p.url)) + '" style="display:flex;align-items:center;gap:14px;padding:10px 20px">' +
          '<span class="s2-field" style="width:72px;height:72px;flex-shrink:0">' + imgTag((p.featured_image && p.featured_image.url) || p.image) + '</span>' +
          '<span style="display:flex;flex-direction:column;gap:3px;flex-grow:1;min-width:0"><span class="s2-mono s2-muted">' + esc(p.vendor) + '</span><span style="font-size:16px;font-weight:600;line-height:1.25">' + esc(cleanTitle(p.title)) + '</span></span>' +
          '<span class="s2-price" style="white-space:nowrap">' + (price ? kd(price) : '') + '</span></a>';
      });
    }
    (r.collections || []).slice(0, 3).forEach(function (c) {
      html += '<a href="' + esc(loc(c.url)) + '" class="s2-mrow" style="min-height:52px"><span class="s2-mrow__l">' + esc(cleanTitle(c.title)) + '</span><span class="s2-mrow__chev s2-mrow__go">' + ICON_RIGHT + '</span></a>';
    });
    if (!html) html = '<p class="s2-body s2-muted" style="padding:20px">' + esc(t('s_none')) + '</p>';
    html += '<div style="padding:16px 20px 24px"><a class="s2-btn s2-btn--ink s2-btn--block" href="' + ROOT + 'search?q=' + encodeURIComponent(withSyn(q)) + '&options%5Bprefix%5D=last">' + esc(t('s_all')).replace('%q', esc(q)) + '</a></div>';
    box.innerHTML = html;
  }
  function imgTag(src) {
    if (!src) return '';
    src = String(src);
    src += (src.indexOf('?') > -1 ? '&' : '?') + 'width=160';
    return '<img class="s2-cover" alt="" loading="lazy" src="' + esc(src) + '">';
  }
  /* Shopify's predictive search refuses the Arabic locale (/ar/search/suggest.json answers
     417 "Unsupported buyer locale"), so every query goes to the root endpoint, which does
     match Arabic text in titles and descriptions. Links are sent back to /ar afterwards.
     SYN maps Arabic plurals, colours, movements and brand names (and a few English
     variants) to the English words the catalogue is written in; when a query maps, both
     are searched and the mapped results lead. Keys are normalised (see normAr). */
  var SUGGEST = '/search/suggest.json';
  var ARABIC = /[؀-ۿ]/;
  var SYN = {
    'حزام': 'strap', 'احزمه': 'strap', 'حزامات': 'strap', 'سير': 'strap', 'سوار': 'bracelet', 'اساور': 'bracelet', 'اسواره': 'bracelet',
    'جلد': 'leather', 'جلدي': 'leather', 'مطاط': 'rubber', 'ربل': 'rubber', 'سيليكون': 'rubber', 'ناتو': 'nato', 'قماش': 'canvas', 'ستيل': 'steel', 'شبك': 'mesh',
    'اوتوماتيك': 'automatic', 'اتوماتيك': 'automatic', 'اوتوماتيكي': 'automatic', 'اوتوماتيكيه': 'automatic', 'كوارتز': 'quartz', 'بطاريه': 'quartz', 'يدوي': 'hand-wound', 'كرونوغراف': 'chronograph', 'كرونو': 'chronograph',
    'نسائي': 'ladies', 'نسائيه': 'ladies', 'حريمي': 'ladies', 'للنساء': 'ladies', 'نساء': 'ladies', 'بناتي': 'ladies',
    'غوص': 'diver', 'غطس': 'diver', 'رياضي': 'sport', 'رياضيه': 'sport', 'رسمي': 'dress', 'رسميه': 'dress', 'كلاسيك': 'dress', 'كلاسيكي': 'dress',
    'محدود': 'limited', 'محدوده': 'limited', 'مرقمه': 'limited', 'نقش': 'engrave', 'حفر': 'engrave', 'هديه': 'gift',
    'ازرق': 'blue', 'زرقاء': 'blue', 'كحلي': 'navy', 'سماوي': 'sky blue', 'اخضر': 'green', 'خضراء': 'green', 'اسود': 'black', 'سوداء': 'black',
    'ابيض': 'white', 'بيضاء': 'white', 'بني': 'brown', 'بنيه': 'brown', 'احمر': 'red', 'حمراء': 'red', 'عنابي': 'burgundy', 'ذهبي': 'gold', 'ذهبيه': 'gold',
    'فضي': 'silver', 'فضيه': 'silver', 'رمادي': 'grey', 'وردي': 'pink', 'زهري': 'pink', 'بيج': 'cream', 'كريمي': 'cream', 'برتقالي': 'orange',
    'اصفر': 'yellow', 'صفراء': 'yellow', 'فيروزي': 'turquoise', 'تركواز': 'turquoise', 'سلمون': 'salmon',
    'ولبروك': 'wolbrook', 'وولبروك': 'wolbrook', 'ناقا': 'naga', 'ناغا': 'naga', 'ناجا': 'naga', 'ايزوتوب': 'isotope', 'ويكورد': 'wecord',
    'بوفورت': 'beaufort', 'سميثس': 'smiths', 'سمثس': 'smiths', 'فوسترا': 'vostra', 'مانديتبروت': 'mandetbrote',
    'women': 'ladies', 'woman': 'ladies', 'womens': 'ladies', 'lady': 'ladies', 'female': 'ladies', 'diving': 'diver', 'dive': 'diver',
    'auto': 'automatic', 'handwound': 'hand-wound', 'straps': 'strap', 'band': 'strap', 'bands': 'strap', 'bracelets': 'bracelet', 'gray': 'grey'
  };
  var SYN2 = [['فون دورن', 'von doren'], ['اباوت فنتج', 'about vintage'], ['اباوت فينتج', 'about vintage'], ['ويليام وود', 'william wood'],
    ['وليام وود', 'william wood'], ['ديو مير', 'deux mers'], ['دو مير', 'deux mers'], ['ميك اكسب', 'mec exp'], ['نو نيمز', 'no names'],
    ['تول ووتش', 'tool watch'], ['جي ام تي', 'gmt'], ['تعبئه يدويه', 'hand-wound']];
  function normAr(s) {
    return String(s || '').toLowerCase().replace(/[ً-ٰٟـ]/g, '').replace(/[أإآ]/g, 'ا').replace(/ى/g, 'ي').replace(/ة/g, 'ه').replace(/\s+/g, ' ').trim();
  }
  function expand(q) {
    var n = ' ' + normAr(q) + ' ', out = [];
    SYN2.forEach(function (p) { var k = ' ' + normAr(p[0]) + ' '; if (n.indexOf(k) > -1) { out.push(p[1]); n = n.replace(k, ' '); } });
    n.trim().split(' ').forEach(function (w) {
      if (!w) return;
      var m = SYN[w] || (w.indexOf('ال') === 0 && SYN[w.slice(2)]) || (w.indexOf('وال') === 0 && SYN[w.slice(3)]) || (w.indexOf('لل') === 0 && SYN[w.slice(2)]);
      if (m && out.indexOf(m) < 0) out.push(m);
    });
    return out.join(' ');
  }
  function loc(u) { u = String(u || ''); return (AR && u.charAt(0) === '/' && u.indexOf('/ar/') !== 0) ? '/ar' + u : u; }
  function cleanTitle(t) {
    /* "AV86 x STR Kashafa | الكَشّافة (Limited Edition of 100)" -> "AV86 x STR Kashafa" (EN) / "الكَشّافة" (AR) */
    t = String(t || '').replace(/\s*\((?:[^)]*(?:limited|edition)[^)]*|[^)]*[؀-ۿ][^)]*)\)/ig, '').trim();
    if (!ARABIC.test(t)) return t;
    var ar = [], en = [];
    t.split(/\s+[|—–]\s+/).forEach(function (x) { x = x.trim(); if (x) (ARABIC.test(x) ? ar : en).push(x); });
    return (AR && ar.length ? ar.join(' ') : en.join(' — ')) || t;
  }
  function withSyn(q) { var x = expand(q); return (ARABIC.test(q) && x) ? q + ' ' + x : q; }
  function suggest(q) {
    return fetch(SUGGEST + '?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last')
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function merge(a, b) { /* a leads (the mapped query), b follows; de-duplicated by path */
    if (!a || !a.resources) return b;
    if (!b || !b.resources) return a;
    var ra = a.resources.results || {}, rb = b.resources.results || {}, out = {};
    ['products', 'collections', 'queries'].forEach(function (k) {
      var seen = {}, list = [];
      /* suggested searches come only from what the shopper typed, never the mapped English words */
      (k === 'queries' ? (rb[k] || []) : (ra[k] || []).concat(rb[k] || [])).forEach(function (it) { var key = String(it.url || it.text || '').split('?')[0]; if (!seen[key]) { seen[key] = 1; list.push(it); } });
      out[k] = list;
    });
    return { resources: { results: out } };
  }
  function searchRun(q) {
    q = (q || '').trim();
    sq = q;
    if (!q) { searchRender('', null); return; }
    var x = expand(q);
    Promise.all([suggest(q), (x && x !== normAr(q)) ? suggest(x) : Promise.resolve(null)]).then(function (res) {
      if (sq === q) searchRender(q, merge(res[1], res[0]));
    });
  }
  var ICON_SEARCH = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7.5"></circle><path d="m20.5 20.5-4.2-4.2"></path></svg>';
  var ICON_RIGHT = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><path d="m9 18 6-6-6-6"></path></svg>';
  d.addEventListener('input', function (e) {
    if (!e.target.matches('[data-s2-q]')) return;
    clearTimeout(sTimer);
    var v = e.target.value;
    sTimer = setTimeout(function () { searchRun(v); }, 180);
  });
  d.addEventListener('submit', function (e) {
    var f = e.target.closest('[data-s2-sform]');
    if (!f) return;
    var inp = $('[data-s2-q]', f), q = (inp || {}).value || '';
    if (!q.trim()) { e.preventDefault(); return; }
    if (inp) inp.value = withSyn(q.trim());
  });

  /* ---------- finder: three questions -> a filtered watch list ---------- */
  var F = { who: null, style: null, budget: null, step: 1 };
  function finderReset() { F = { who: null, style: null, budget: null, step: 1 }; finderPaint(); }
  function finderPaint() {
    var ov = $('[data-s2-ov="finder"]');
    if (!ov) return;
    $$('[data-s2-fstep]', ov).forEach(function (s) { s.hidden = String(F.step) !== s.getAttribute('data-s2-fstep'); });
    $$('[data-s2-fbar] i', ov).forEach(function (b, i) { b.classList.toggle('is-on', i < F.step); });
    var cnt = $('[data-s2-fcount]', ov); if (cnt) cnt.textContent = t('f_q').replace('%n', F.step);
    $$('[data-s2-fopt]', ov).forEach(function (o) { var kv = o.getAttribute('data-s2-fopt').split(':'); o.setAttribute('aria-pressed', F[kv[0]] === kv[1] ? 'true' : 'false'); });
    var back = $('[data-s2-fback]', ov); if (back) back.disabled = F.step === 1;
    var next = $('[data-s2-fnext]', ov);
    if (next) { next.textContent = F.step === 3 ? t('f_show') : t('f_next'); }
  }
  function finderGo() {
    var tags = [];
    if (F.who === 'her') tags.push('ladies');
    var styleTag = { everyday: 'everyday', dress: 'dress', sport: 'sport', special: 'limited-edition' }[F.style];
    var b = { u100: [0, 100], b100: [100, 150], b150: [150, 250], o250: [250, 0] }[F.budget];
    function url(tg, bud) {
      var u = ROOT + 'collections/watches' + (tg.length ? '/' + tg.join('+') : '');
      var qs = [];
      if (bud) { if (bud[0]) qs.push('filter.v.price.gte=' + bud[0]); if (bud[1]) qs.push('filter.v.price.lte=' + bud[1]); }
      return u + (qs.length ? '?' + qs.join('&') : '');
    }
    function count(tg, bud) {
      return fetch(ROOT + 'collections/watches' + (tg.length ? '/' + tg.join('+') : '') + '/products.json?limit=250').then(function (r) { return r.json(); }).then(function (j) {
        return (j.products || []).filter(function (p) {
          var pr = parseFloat((p.variants && p.variants[0] && p.variants[0].price) || 0);
          if (!bud) return true;
          return (!bud[0] || pr >= bud[0]) && (!bud[1] || pr <= bud[1]);
        }).length;
      }).catch(function () { return 1; });
    }
    var tries = [[tags.concat(styleTag ? [styleTag] : []), b], [tags.concat(styleTag ? [styleTag] : []), null], [tags, b], [[], b], [[], null]];
    var btn = $('[data-s2-fnext]');
    if (btn) btn.textContent = t('f_looking');
    (function attempt(i) {
      var tr = tries[i];
      count(tr[0], tr[1]).then(function (n) {
        if (n > 0 || i === tries.length - 1) { window.location.href = url(tr[0], tr[1]) + (i > 0 ? (url(tr[0], tr[1]).indexOf('?') > -1 ? '&' : '?') + 's2closest=1' : ''); }
        else attempt(i + 1);
      });
    })(0);
  }
  d.addEventListener('click', function (e) {
    var o = e.target.closest('[data-s2-fopt]');
    if (o) { var kv = o.getAttribute('data-s2-fopt').split(':'); F[kv[0]] = kv[1]; finderPaint(); setTimeout(function () { if (F.step < 3) { F.step++; finderPaint(); } }, 220); return; }
    if (e.target.closest('[data-s2-fback]')) { if (F.step > 1) { F.step--; finderPaint(); } return; }
    if (e.target.closest('[data-s2-fskip]')) { if (F.step < 3) { F.step++; finderPaint(); } else finderGo(); return; }
    if (e.target.closest('[data-s2-fnext]')) { if (F.step < 3) { F.step++; finderPaint(); } else finderGo(); }
  });

  /* ---------- shop the look: add all ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-s2-addall]');
    if (!b) return;
    e.preventDefault();
    var ids = b.getAttribute('data-s2-addall').split(',').filter(Boolean);
    var label = b.innerHTML;
    b.textContent = t('adding');
    fetch(ROOT + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: ids.map(function (id) { return { id: +id, quantity: 1 }; }) }) })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .then(function () { window.location.href = ROOT + 'cart'; })
      .catch(function () { b.innerHTML = label; window.location.href = b.getAttribute('href') || (ROOT + 'cart'); });
  });

  /* ---------- Kuwait City clock ---------- */
  function clock() {
    var s;
    try { s = new Intl.DateTimeFormat('en-GB', { hour: '2-digit', minute: '2-digit', hour12: false, timeZone: 'Asia/Kuwait' }).format(new Date()); } catch (e) { return; }
    $$('[data-s2-clock]').forEach(function (el) { el.textContent = s; });
  }

  /* ---------- currency pill: keep it in our header / menu, never floating ---------- */
  function placeCurrency() {
    var pill = $('[data-smiths-cur]');
    if (!pill) return;
    var desk = window.matchMedia('(min-width: 1024px)').matches;
    var host = desk ? $('[data-s2-cur-host="desk"]') : $('[data-s2-cur-host="menu"]');
    if (!host) return;
    if (pill.parentNode !== host) host.appendChild(pill);
    pill.classList.remove('smiths-cur--float');
    pill.classList.add('smiths-cur--header');
    pill.hidden = false;
  }
  d.addEventListener('smiths:currency', placeCurrency);

  function boot() {
    paintSaved();
    clock(); setInterval(clock, 20000);
    placeCurrency();
    try { window.matchMedia('(min-width: 1024px)').addEventListener('change', placeCurrency); } catch (e) {}
    /* a closest-match landing from the finder says so */
    if (/[?&]s2closest=1/.test(location.search)) { var n = $('[data-s2-closest]'); if (n) n.hidden = false; }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();
  window.S2 = { open: openOv, close: closeOv, refreshCart: refreshCart };
})();
